export default __webpack_public_path__ + "static/media/link.94a5d4a7.svg";